import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const HomePage = () => import('../views/HomePage')
const Ofd = () => import('../views/Ofd')


const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [{
      path: '/',
      component: HomePage
    },
    {
      path: '/ofd',
      component: Ofd
    }
  ]
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js